import { PipeTransform, Pipe } from "@angular/core";
import { CalendarSearchService } from "./calendar-search.service";

@Pipe({
  name: "highlightSearchResults",
})
export class CalendarSearchPipe implements PipeTransform {
  constructor(private calendarSearchService: CalendarSearchService) {}
  transform(text: string, itemId: string) {
    return this.calendarSearchService.highlightTerm(text, itemId);
  }
}
